import React, { useEffect, useState } from 'react'
import { usePaymentSuccess } from './PaymentStatusContext';

export default function Paymentsuccess() {
  const { show , data} = usePaymentSuccess();
  const [open, setOpen] = useState(false)
  const handleClose = () => {
    setOpen(false);
    window.location.reload();
  }
  useEffect(() => {
    if(data&&data.status === "success"){
      setOpen(show);
    } else {
      setOpen(false);
    }
  }, [show,data]);
  // Handle escape key press
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        handleClose()
      }
    }

    document.addEventListener('keydown', handleEscape)
    return () => document.removeEventListener('keydown', handleEscape)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  // Handle click outside modal
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose()
    }
  }
  if(!open) return null
  return (
    <div
      className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center px-4 z-50 animate-fadeIn"
      onClick={handleBackdropClick}
    >
      <div className="bg-white rounded-xl shadow-2xl p-6 max-w-md w-full mx-4 animate-slideUp relative border border-gray-100 max-h-[90vh] overflow-y-auto">
        {/* Modern Close Button - Positioned inside the modal */}
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 bg-white rounded-full p-2 shadow-lg hover:bg-gray-50 transition-all duration-300 hover:scale-110 z-10 border border-gray-200 hover:border-gray-300"
          aria-label="Close modal"
        >
          <svg
            className="h-4 w-4 text-gray-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        {/* Modern Success Icon */}
        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-xl bg-gradient-to-br from-green-500/10 to-green-600/20 mb-4 shadow-lg animate-bounceIn border border-green-200/50">
          <div className="relative">
            <svg
              className="h-8 w-8 text-green-500 animate-pulse"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
            <div className="absolute inset-0 bg-green-500/20 rounded-full animate-ping"></div>
          </div>
        </div>

        {/* Modern Title */}
        <h2 className="text-xl font-bold text-gray-900 text-center mb-3 animate-slideInUp bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent">
          Payment Successful!
        </h2>

        {/* Modern Message */}
        <p className="text-gray-600 text-center mb-4 leading-relaxed animate-slideInUp animation-delay-200 text-sm">
          Your payment for {data.courseTitle} of ₹{data.amount} has been
          processed successfully. Thank you for your purchase!
          {data.transactionId && (
            <span className="block mt-2">Payment ID: {data.paymentId}</span>
          )}
        </p>

        {/* Modern Success Information */}
        <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200/50 rounded-lg p-3 mb-6 animate-slideInUp animation-delay-300 shadow-sm">
          <div className="flex items-start space-x-2">
            <div className="flex-shrink-0">
              <div className="w-6 h-6 bg-green-500/10 rounded-md flex items-center justify-center">
                <svg
                  className="h-3 w-3 text-green-600 animate-wiggle"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
            </div>
            <div>
              <h3 className="text-xs font-semibold text-green-900 mb-1">
                What's Next?
              </h3>
              <p className="text-xs text-green-800 leading-relaxed">
                You can now access the course content and start learning.
              </p>
            </div>
          </div>
        </div>

        {/* Action Button */}
        <div className="animate-slideInUp animation-delay-400">
          <button
            onClick={handleClose}
            className="w-full py-3 px-4 bg-gradient-to-r from-green-500 to-green-600 text-white rounded-lg hover:from-green-600 hover:to-green-700 transition-all duration-300 font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-1 hover:scale-105 active:scale-95 border-0 focus:outline-none focus:ring-2 focus:ring-green-500/50 text-sm"
          >
            Continue Learning
          </button>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(30px) scale(0.9);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }

        @keyframes bounceIn {
          0% {
            opacity: 0;
            transform: scale(0.3) translateY(-50px);
          }
          50% {
            opacity: 1;
            transform: scale(1.05) translateY(0);
          }
          70% {
            transform: scale(0.9) translateY(0);
          }
          100% {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }

        @keyframes slideInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes wiggle {
          0%,
          7% {
            transform: rotateZ(0);
          }
          15% {
            transform: rotateZ(-15deg);
          }
          20% {
            transform: rotateZ(10deg);
          }
          25% {
            transform: rotateZ(-10deg);
          }
          30% {
            transform: rotateZ(6deg);
          }
          35% {
            transform: rotateZ(-4deg);
          }
          40%,
          100% {
            transform: rotateZ(0);
          }
        }

        .animate-fadeIn {
          animation: fadeIn 0.4s ease-out;
        }

        .animate-slideUp {
          animation: slideUp 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }

        .animate-bounceIn {
          animation: bounceIn 0.8s ease-out;
        }

        .animate-slideInUp {
          animation: slideInUp 0.6s ease-out forwards;
          opacity: 0;
        }

        .animate-wiggle {
          animation: wiggle 2s ease-in-out infinite;
        }

        .animation-delay-200 {
          animation-delay: 0.2s;
        }

        .animation-delay-300 {
          animation-delay: 0.3s;
        }

        .animation-delay-400 {
          animation-delay: 0.4s;
        }
      `}</style>
    </div>
  );
}
